<template>

    <div id="right-panel" class="right-panel fContainer">

        <SellHeader></SellHeader>

        <div class="content mt-3 fColumn">
            <div class="animated fadeIn fColumn">
                <form action="/" method="post" id="form" class="userForm ajaxForm fColumn">
                    <div class="card     fColumn ">
                        <div class="card-header     fHead">
                            <strong>{{$t('closes.title')}}</strong>
                            <div class="float-right">
                            </div>
                        </div>
                        <div class="fContent">
                            <div class="card-body card-block ">
                                <form action="" method="post" class="">

                                    <div class="hiddenSzb">
                                        <input type="text" name="del">
                                        <input type="text" id="id" name="id" class="form-control id" value="">
                                    </div>

                                    <div class="row form-group">
                                        <div class="col-12">
                                            <!--{{data}}-->
                                            <!--<div class="closesDataContainer">{{$t('closes.actualDate')}} {{this.data.dateContainer}}</div>-->

                                            <div v-if="justDate" class="closesDataContainer">{{$t('closes.closesActualDay')}} {{dtT}} </div>
                                            <div v-if="!justDate" class="closesDataContainer">{{$t('closes.closesActualPeriod')}} {{dtStartFormat}} - {{dtStopFormat}}</div>

                                            <span class="closesDataContainer" v-if="(!isNaN(data.closesSumSum))">
                                                {{$t('closes.closesSumSum')}}<small class="">{{prefix}}</small><span class="">{{data.closesSumSum}}</span><small class="">{{suffix}}</small>
                                            </span><br>
                                            <span class="closesDataContainer" v-if="(!isNaN(data.closesSumCash))">
                                                {{$t('closes.closesSumCash')}}<small class="">{{prefix}}</small><span class="">{{data.closesSumCash}}</span><small class="">{{suffix}}</small>
                                            </span><br>
                                            <span class="closesDataContainer" v-if="(!isNaN(data.closesSumCard))">
                                                {{$t('closes.closesSumCard')}}<small class="">{{prefix}}</small><span class="">{{data.closesSumCard}}</span><small class="">{{suffix}}</small>
                                            </span><br>
                                            <span class="closesDataContainer" v-if="(!isNaN(data.closesSumTransfer))">
                                                {{$t('closes.closesSumTransfer')}}<small class="">{{prefix}}</small><span class="">{{data.closesSumTransfer}}</span><small class="">{{suffix}}</small>
                                            </span><br>
                                            <hr>
                                            <!--<span class="closesDataContainer" v-if="(!isNaN(data.closesCashRegisterOpens))">-->
                                                <!--{{$t('closes.closesCashRegisterOpens')}}<small class="">{{prefix}}</small><span class="">{{data.closesCashRegisterOpens}}</span><small class="">{{suffix}}</small>-->
                                            <!--</span><br>-->
                                            <!--<span class="closesDataContainer" v-if="(!isNaN(data.closesCashRegisterCloses))">-->
                                                <!--{{$t('closes.closesCashRegisterCloses')}}<small class="">{{prefix}}</small><span class="">{{data.closesCashRegisterCloses}}</span><small class="">{{suffix}}</small>-->
                                            <!--</span><br>-->
                                            <span class="closesDataContainer" v-if="(!isNaN(data.closesSumCashRegister))">
                                                {{$t('closes.closesSumCashRegister')}}<small class="">{{prefix}}</small><span class="">{{data.closesSumCashRegister}}</span><small class="">{{suffix}}</small>
                                            </span><br>

                                            <!--<span class="closesDataContainer" v-if="(!isNaN(this.data.SellsByDate))">-->
                                            <!--{{$t('closes.SellsByDateContainer')}} <small class="">{{prefix}}</small>{{this.data.SellsByDate}} <small class="">{{suffix}}</small>-->
                                            <!--<br>-->
                                            <!--<span class="closesDataContainer" v-if="(!isNaN(this.data.SellsByDateCash))">-->
                                            <!--{{$t('closes.SellsByDateContainerCash')}} <small class="">{{prefix}}</small>{{this.data.SellsByDateCash}} <small class="">{{suffix}}</small>-->
                                            <!--</span>-->
                                            <!--<span class="closesDataContainer" v-if="(isNaN(this.data.SellsByDateCash))">-->
                                            <!--{{$t('closes.SellsByDateContainer2Cash')}}-->
                                            <!--</span>-->
                                            <!--<br>-->
                                            <!--<span class="closesDataContainer" v-if="(!isNaN(this.data.SellsByDateCard))">-->
                                            <!--{{$t('closes.SellsByDateContainerCard')}} <small class="">{{prefix}}</small>{{this.data.SellsByDateCard}} <small class="">{{suffix}}</small>-->
                                            <!--</span>-->
                                            <!--<span class="closesDataContainer" v-if="(isNaN(this.data.SellsByDateCard))">-->
                                            <!--{{$t('closes.SellsByDateContainer2Card')}}-->
                                            <!--</span>-->
                                            <!--<br>-->
                                            <!--</span>-->

                                            <button type="button" class="btn btn-success btn-lgX btn-day" v-on:click="actualPeriodPrint">
                                                <i class="fa fa-dot-circle-o"></i> {{$t('closes.actualPeriodPrint')}}
                                            </button>

                                            <!--Old-->
                                            <!--<span class="closesDataContainer" v-if="(isNaN(this.data.SellsByDate))">-->
                                            <!--{{$t('closes.SellsByDateContainer2')}}-->
                                            <!--</span>-->
                                            <!--<br>-->
                                            <!--<button type="button" class="btn btn-success btn-lgX btn-day" v-on:click="actualDayPrint">-->
                                            <!--<i class="fa fa-dot-circle-o"></i> {{$t('closes.actualDayPrint')}}-->
                                            <!--</button>-->
                                            <!--<button type="button" class="btn btn-success btn-lgX btn-dayPrev" v-on:click="previousDayPrint">-->
                                            <!--<i class="fa fa-dot-circle-o"></i> {{$t('closes.previousDayPrint')}}-->
                                            <!--</button>-->
                                            <!--End of old-->


                                            <!--Employee don't see the monthly-->
                                            <!--<hr>-->
                                            <!--<div class="closesDataContainer">{{$t('closes.actualMonth')}} {{this.data.monthContainer}}</div>-->
                                            <!--<span class="closesDataContainer" v-if="(!isNaN(this.data.SellsByMonth))">-->
                                            <!--{{$t('closes.SellsByMonthContainer')}} <small class="">{{prefix}}</small>{{this.data.SellsByMonth}} <small class="">{{suffix}}</small>-->
                                            <!--</span>-->
                                            <!--<span class="closesDataContainer" v-if="(isNaN(this.data.SellsByMonth))">-->
                                            <!--{{$t('closes.SellsByMonthContainer2')}}-->
                                            <!--</span>-->
                                            <!--<br>-->
                                            <!--<button type="button" class="btn btn-success btn-lgX btn-month" v-on:click="actualMonthPrint">-->
                                            <!--<i class="fa fa-dot-circle-o"></i> {{$t('closes.actualMonthPrint')}}-->
                                            <!--</button>-->
                                            <!--<button type="button" class="btn btn-success btn-lgX btn-monthPrev" v-on:click="previousMonthPrint">-->
                                            <!--<i class="fa fa-dot-circle-o"></i> {{$t('closes.previousMonthPrint')}}-->
                                            <!--</button>-->
                                        </div>
                                    </div>


                                </form>
                            </div>
                        </div>
                        <div class="card-footer text-center fFix">
                        </div>
                    </div>

                </form>

            </div><!-- .animated -->
        </div><!-- .content -->

    </div>

</template>


<script>
    import LngChooser from '@/components/LngChooser.vue';
    import AlertInPage from '@/components/AlertInPage.vue';
    import Helper from '@/helper/Helper';
    import InputText from '@/components/InputText.vue';
    import SellHeader from "../components/SellHeader";
    const moment = require('moment');
    import Api from '@/api/Api';
//    import SyncHandler from '@/sync/syncHandler';
//    const machineId = require('node-machine-id').machineId;
//    const machineIdSync = require('node-machine-id').machineIdSync;

    export default {
        name: 'Closes',
        roles: [1, 2, 3, 7, 8, 9],
        data() {
            return {
                prefix: "",
                suffix: "",
                dtStart: "",
                dtStop: "",
                dtStartFormat: "",
                dtStopFormat: "",
                dtT: "",
                justDate: true,
                data: {
//                    SellsByDate: ""
//                    , SellsByDateCash: ""
//                    , SellsByDateCard: ""
//                    , SellsByMonth: ""
//                    , SellsByDatePrevious: ""
//                    , SellsByDateCashPrevious: ""
//                    , SellsByDateCardPrevious: ""
//                    , SellsByMonthPrevious: ""
//                    , dateContainerPrevious: moment().subtract(1, 'day').format("YYYY-MM-DD")
//                    , monthContainerPrevious: moment().subtract(1, 'months').format("MM")
//
//                    , dateContainer: moment().format("YYYY-MM-DD")
//                    , monthContainer: moment().format("MM")
                }
                , AlertInPage: {
                    type: "", // primary secondary success danger warning info light dark
                    msg: "",
                    delay: 5000,
                }
            };
        },
        watch: {
            dtStart: function (newVal, oldVal) {
                const modul = this;
                modul.fillJustDate();
            },
            dtStop: function (newVal, oldVal) {
                const modul = this;
                modul.fillJustDate();
            },
            dt: function (newVal, oldVal) {
                const modul = this;
                modul.fillJustDate();
            },
        },
        mounted() {

            const modul = this;
            console.log(this.$route.name + " mounded");
            modul.roles = [3, 4, 5, 6, 7, 8, 9, 10];
          const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
          if (!Helper.checkRoles(modul.roles, role)) {
                modul.$router.push({name: "login"})
            }
            modul.helper = Helper;
            modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
            modul.suffix = Helper.getMoneyDefaultDisplaySuffix();

            // period start - end
            modul.dtStart = moment().startOf('day');
            modul.dtStop = moment().endOf('day');
            modul.dtStartFormat = modul.dtStart.format('YYYY-MM-DD HH:mm:ss');
            modul.dtStopFormat = modul.dtStop.format('YYYY-MM-DD HH:mm:ss');

            modul.fillJustDate();

            modul.$eventBus.$on('globalSyncStatus', modul.globalSyncStatusEventHandler);
            const param = {
//                itemizedlist:true,
//                paramDate : moment().format("YYYY-MM-DD")
//                ,paramDate1 : moment().format("YYYY")
//                ,paramDate2 : moment().format("MM")
//                ,paramDatePrevious : moment().subtract(1, 'day').format("YYYY-MM-DD")
//                ,paramDate1Previous : moment().subtract(1, 'day').format("YYYY")
//                ,paramDate2Previous : moment().subtract(1, 'months').format("MM")

                isCassaGet: true // mark as a new featureset
                , itemizedlist: false
                , isStore: false // It comes from data + property --
                , periodDtFrom: modul.dtStart.clone().utc().format('YYYY-MM-DD HH:mm:ss') // It comes from data + property -- // HH:ii:ss
                , periodDtTo: modul.dtStop.clone().utc().format('YYYY-MM-DD HH:mm:ss') // It comes from data + property --
                , wsid: localStorage.getItem("browserIdentifier") //machineIdSync()
            };
//            const param={};
//          param.machinekey=localStorage.getItem("browserIdentifier");
//          param.utcOffset=
//            dateTo: dateTo
//            , utcOffset: moment().utcOffset()

          Api.getCloses(param).then(function (res) {
            if (res && res.result === true && res.data) {
                modul.fillData(res.data)
              }
//              cb(null, e.data);
          }, function (err) {
            console.log(err)
//            cb(err, null);
          });


//            SyncHandler.Datasync.getCloses(param).then(function (result, reject) {
//                console.log(result);
//                console.log(reject);
//            });
        },
        beforeDestroy() {
            const modul = this;
            modul.$eventBus.$off('globalSyncStatus');
        },
        methods: {
            fillJustDate(){
                const modul = this;
                if (modul.dtStart.format('YYYY-MM-DD HH:mm:ss') === modul.dtStart.format('YYYY-MM-DD 00:00:00') &&
                    modul.dtStop.format('YYYY-MM-DD HH:mm:ss') === modul.dtStop.format('YYYY-MM-DD 23:59:59')
                ) {
                    modul.justDate = true;
                    modul.dtT = modul.dtStart.format('YYYY-MM-DD')
                } else {
                    modul.justDate = false;
                    modul.dtT = "-"
                }
            },
            globalSyncStatusEventHandler(o){
                const modul = this;
                if (o && o.status === "success" && o.result && o.result.data) {
                    modul.fillData(o.result.data)
                }
            },
            fillData(data){
                const modul = this;
                console.log(data);


                const dataNew = {};
                dataNew.closesSumCashRegister = (data.closesSumCashRegister && data.closesSumCashRegister[0] && data.closesSumCashRegister[0].sum) ? Helper.getFormattedSumprice(Helper.Number = (data.closesSumCashRegister[0].sum)) : "-";
                dataNew.closesCashRegisterOpens = (data.closesCashRegisterOpens && data.closesCashRegisterOpens[0] && data.closesCashRegisterOpens[0].sum) ? Helper.getFormattedSumprice(Helper.Number = (data.closesCashRegisterOpens[0].sum)) : "-";
                dataNew.closesCashRegisterCloses = (data.closesCashRegisterCloses && data.closesCashRegisterCloses[0] && data.closesCashRegisterCloses[0].sum) ? Helper.getFormattedSumprice(Helper.Number = (data.closesCashRegisterCloses[0].sum)) : "-";
                dataNew.closesSumSum = (data.closesSumSum && data.closesSumSum[0] && data.closesSumSum[0].sum) ? Helper.getFormattedSumprice(Helper.Number = (data.closesSumSum[0].sum)) : "-";
                dataNew.closesSumCash = (data.closesSumCash && data.closesSumCash[0] && data.closesSumCash[0].sum) ? Helper.getFormattedSumprice(Helper.Number = (data.closesSumCash[0].sum)) : "-";
                dataNew.closesSumCard = (data.closesSumCard && data.closesSumCard[0] && data.closesSumCard[0].sum) ? Helper.getFormattedSumprice(Helper.Number = (data.closesSumCard[0].sum)) : "-";
                dataNew.closesSumTransfer = (data.closesSumTransfer && data.closesSumTransfer[0] && data.closesSumTransfer[0].sum) ? Helper.getFormattedSumprice(Helper.Number = (data.closesSumTransfer[0].sum)) : "-";
                dataNew.closesItemizedList = (data.closesItemizedList) ? data.closesItemizedList : [];
                modul.data = dataNew;
                console.log(modul.data);


//                modul.data.SellsByDate = Helper.getFormattedSumprice(data.SellsByDate);
//                modul.data.SellsByDateCash = Helper.getFormattedSumprice(data.SellsByDateCash);
//                modul.data.SellsByDateCard = Helper.getFormattedSumprice(data.SellsByDateCard);
//                modul.data.SellsByMonth = Helper.getFormattedSumprice(data.SellsByMonth);
//                modul.data.SellsByDatePrevious = Helper.getFormattedSumprice(data.SellsByDatePrevious);
//                modul.data.SellsByDateCashPrevious = Helper.getFormattedSumprice(data.SellsByDateCashPrevious);
//                modul.data.SellsByDateCardPrevious = Helper.getFormattedSumprice(data.SellsByDateCardPrevious);
//                modul.data.SellsByMonthPrevious = Helper.getFormattedSumprice(data.SellsByMonthPrevious);
//                modul.data.SellsByDateItemizedList = data.SellsByDateItemizedList;
//                modul.data.SellsByDateItemizedListPrevious = data.SellsByDateItemizedListPrevious;

            },
            actualPeriodPrint(){
                const modul = this;
                const param = {
                    name: "closesprint",
                    params: {
                        type: "actualPeriodPrint",
                        justDate: modul.justDate,
                        dtT: modul.dtT,
                        dtStartFormat: modul.dtStartFormat,
                        dtStopFormat: modul.dtStopFormat,
                        closesSumSum: Helper.getFormattedSumprice(Number(modul.data.closesSumSum)),
                        closesSumCash: Helper.getFormattedSumprice(Number(modul.data.closesSumCash)),
                        closesSumCard: Helper.getFormattedSumprice(Number(modul.data.closesSumCard)),
                        closesSumTransfer: Helper.getFormattedSumprice(Number(modul.data.closesSumTransfer)),
                        closesCashRegisterOpens: Helper.getFormattedSumprice(Number(modul.data.closesCashRegisterOpens)),
                        closesCashRegisterCloses: Helper.getFormattedSumprice(Number(modul.data.closesCashRegisterCloses)),
                        closesSumCashRegister: Helper.getFormattedSumprice(Number(modul.data.closesSumCashRegister)),
                        closesItemizedList: modul.data.closesItemizedList,
                    }
                };
                modul.$router.push(param)
            },
            actualDayPrint(){
                const modul = this;
                modul.$router.push({
                    name: "closesprint",
                    params: {
                        type: "actualDayPrint",
                        SellsByDate: Helper.getFormattedSumprice(Number(modul.data.SellsByDate)),
                        SellsByDateCash: Helper.getFormattedSumprice(Number(modul.data.SellsByDateCash)),
                        SellsByDateCard: Helper.getFormattedSumprice(Number(modul.data.SellsByDateCard)),
                        SellsByMonth: Helper.getFormattedSumprice(Number(modul.data.SellsByMonth)),
                        dateContainer: modul.data.dateContainer,
                        monthContainer: modul.data.monthContainer
                        , SellsByDateItemizedList: modul.data.SellsByDateItemizedList



                    }
                })
            },
            previousDayPrint(){
                const modul = this;
                modul.$router.push({
                    name: "closesprint",
                    params: {
                        type: "previousDayPrint",
                        SellsByDate: Helper.getFormattedSumprice(Number(modul.data.SellsByDatePrevious)),
                        SellsByDateCash: Helper.getFormattedSumprice(Number(modul.data.SellsByDateCashPrevious)),
                        SellsByDateCard: Helper.getFormattedSumprice(Number(modul.data.SellsByDateCardPrevious)),
                        SellsByMonth: Helper.getFormattedSumprice(Number(modul.data.SellsByMonthPrevious)),
                        dateContainer: modul.data.dateContainerPrevious,
                        monthContainer: modul.data.monthContainerPrevious
                        , SellsByDateItemizedList: modul.data.SellsByDateItemizedListPrevious

                    }
                })
            },
            actualMonthPrint(){
                const modul = this;
                modul.$router.push({
                    name: "closesprint",
                    params: {
                        type: "actualMonthPrint",
                        SellsByDate: Helper.getFormattedSumprice(Number(modul.data.SellsByDate)),
                        SellsByDateCash: Helper.getFormattedSumprice(Number(modul.data.SellsByDateCash)),
                        SellsByDateCard: Helper.getFormattedSumprice(Number(modul.data.SellsByDateCard)),
                        SellsByMonth: Helper.getFormattedSumprice(Number(modul.data.SellsByMonth)),
                        dateContainer: modul.data.dateContainer,
                        monthContainer: modul.data.monthContainer
                    }
                })
            },
            previousMonthPrint(){
                const modul = this;
                modul.$router.push({
                    name: "closesprint",
                    params: {
                        type: "previousMonthPrint",
                        SellsByDate: Helper.getFormattedSumprice(Number(modul.data.SellsByDatePrevious)),
                        SellsByDateCash: Helper.getFormattedSumprice(Number(modul.data.SellsByDateCashPrevious)),
                        SellsByDateCard: Helper.getFormattedSumprice(Number(modul.data.SellsByDateCardPrevious)),
                        SellsByMonth: Helper.getFormattedSumprice(Number(modul.data.SellsByMonthPrevious)),
                        dateContainer: modul.data.dateContainerPrevious,
                        monthContainer: modul.data.monthContainerPrevious
                    }
                })
            },

        },
        components: {
            SellHeader,
            InputText,
            LngChooser,
            AlertInPage,
        },
    };
</script>

<!--SUBSTR(datetime, 1, 4)-->
